import { q, client } from "../helpers/init-db";

/**
 *
 * @param {object} participantData - object containing data of the participant
 */
export function createParticipant(participantData) {
  
  return client
    .query(
      q.Create(q.Collection("participants"), {
        data: {
          ...participantData,
        },
        permissions: {

        }
      })
    )
    .then(resp => resp)
    .catch(error => error);
}

/**
 *
 * @param participantEmail - email of the participant
 */
export function getParticipantByEmail(participantEmail) {
  return client
  .query(
    q.Get(q.Match(q.Index('participant_by_email'), participantEmail))
  )
  .then(resp => resp)
  .catch(error => error);
}

/**
 *
 * @param {object} participantRefID - faunaDb Participants collection reference ID
 * @param {string} newParticipantData - new data for participant
 */
export function updateParticipant(participantRefID, newParticipantData) {
  return client
    .query(
      q.Update(q.Ref(q.Collection("participants"), participantRefID), {
        data: newParticipantData
      })
    )
    .then(resp => resp)
    .catch(err => err);
}